
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 700 700"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M517.97 522.208c-24.6 0-47.8-9.6-65.1-27l-94.1-94.1c-6.6-6.6-18.1-6.6-24.7 0l-94.4 94.4c-17.4 17.4-40.5 27-65.2 27h-18.6l119.2 119.2c37.2 37.2 97.5 37.2 134.7 0l119.5-119.5h-11.3zM174.424 189.507c24.6 0 47.8 9.6 65.1 27l94.4 94.4c6.8 6.8 17.9 6.8 24.7 0l94.1-94.1c17.4-17.4 40.5-27 65.2-27h11.3l-119.5-119.5c-37.2-37.2-97.5-37.2-134.7 0l-119.1 119.2h18.5z"}}),_c('path',{attrs:{"d":"M628.113 288.688l-72.2-72.2c-1.6.6-3.3 1-5.1 1h-32.8c-17 0-33.6 6.9-45.6 18.9l-94.1 94.1c-8.8 8.8-20.4 13.2-31.9 13.2-11.6 0-23.1-4.4-31.9-13.2l-94.4-94.4c-12-12-28.6-18.9-45.6-18.9h-40.4c-1.7 0-3.3-.4-4.8-1l-72.5 72.5c-37.2 37.2-37.2 97.5 0 134.7l72.4 72.5c1.5-.6 3.1-1 4.9-1h40.4c17 0 33.6-6.9 45.6-18.9l94.4-94.4c17.1-17.1 46.8-17.1 63.9 0l94.1 94.1c12 12 28.6 18.9 45.6 18.9h32.8c1.8 0 3.5.4 5.1 1l72.2-72.2c37.1-37.2 37.1-97.5-.1-134.7"}})])
          )
        }
      }
    